import { useCallback, useEffect } from 'react';
import { CaseEventName, caseNotifier, waitForCaseEvent, WsCaseEventMessageContent } from '@/ws';

export const useCaseEventsSubscription = (
  eventNames: CaseEventName[],
  handler?: (content: WsCaseEventMessageContent) => void,
  once = false,
) => {
  useEffect(() => {
    if (handler && eventNames.length) {
      if (once) {
        eventNames.forEach((eventName) => caseNotifier.once(eventName, handler));
      }
      caseNotifier.on(eventNames, handler);
    }
    return () => {
      if (handler && eventNames.length) {
        caseNotifier.off(eventNames, handler);
      }
    };
  }, [eventNames, handler, once]);

  return useCallback(
    (timeoutMs?: number) => {
      if (!eventNames.length) {
        return () => {};
      }

      return eventNames.map((eventName) =>
        timeoutMs ? waitForCaseEvent(eventName, timeoutMs) : waitForCaseEvent(eventName),
      );
    },
    [eventNames],
  );
};
